const typography = {
  sizes: {
    h1: 'text-4xl sm:text-5xl lg:text-6xl',
    h2: 'text-2xl sm:text-3xl lg:text-4xl',
    h3: 'text-2xl sm:text-3xl lg:text-4xl',
    h4: 'text-xl sm:text-2xl lg:text-3xl',
  },
};

export default typography;
